<template>
  <div class="toast-container" aria-live="polite">
    <TransitionGroup name="toast-slide">
      <AppToast v-for="t in toasts" :key="t.id" :toast="t" @dismiss="dismissToast" />
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import AppToast from './AppToast.vue'

const { toasts, dismissToast } = useToast()
</script>
